import { useParams } from 'react-router-dom';

import { Avatar, Divider, Space, Typography } from 'antd';

import { getCdnUrl } from '@/helpers';
import { useGetLessonsQuery } from '@/services/lesson';
import styled, { css, StyledProp } from '@/styled';

const Description = ({ className }: StyledProp) => {
  const { id } = useParams();
  const { data } = useGetLessonsQuery(id);

  const renderDescription = () => {
    if (data?.new_description) {
      return <Typography className='description'>{data?.new_description}</Typography>;
    }

    if (data?.description_type === 'iframe') {
      return <iframe src={data?.iframe_url} height={data?.iframe_config} allow='geolocation; microphone; camera' />;
    }

    return <Typography className='description' dangerouslySetInnerHTML={{ __html: data?.description }} />;
  };

  return (
    <div className={className}>
      {renderDescription()}
      <Divider />
      <Space size={24}>
        <Avatar src={getCdnUrl(data?.author?.avatar, '')} size={82}>
          {data?.author?.name.split('')[0]}
        </Avatar>
        <div>
          <Typography.Title level={4} ellipsis>
            {data?.author?.name}
          </Typography.Title>
          <Typography.Paragraph ellipsis={{ rows: 2 }}>{data?.author?.description}</Typography.Paragraph>
        </div>
      </Space>
    </div>
  );
};
export default styled(Description)(
  ({ theme }) => css`
    .description,
    iframe {
      color: ${theme.colorTextBase} !important;
      white-space: pre-wrap;
    }

    .ant-divider {
      border-block-start: 1px solid ${theme.variables.dividerColor};
      margin-left: -16px;
      width: calc(100% + 32px);
    }

    .ant-space-horizontal,
    .ant-space-item {
      max-width: 100%;
    }

    .ant-avatar-string {
      line-height: 80px;
    }

    .ant-typography,
    svg {
      color: ${theme.colorTextSecondary};
      margin: 0;
    }

    button {
      border: none !important;
    }

    iframe {
      width: 100%;
    }
  `
);
